import React from "react";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthContext } from "./AuthProvider";

export const StaffOnlyRoute = ({ children }: { children: JSX.Element }) => {
    var auth = React.useContext(AuthContext);

    if (!auth.isAuthenticated()) {
        auth.staffSigninRedirect();
        return <AbpnSpinner />;
    }
    return children;

}
